import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExclamationCircleBold: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconExclamationCircleBold"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 14.7998C11.3926 14.7998 10.9006 15.2921 10.9004 15.8994C10.9004 16.5069 11.3925 17 12 17C12.6075 16.9999 13.0996 16.5069 13.0996 15.8994C13.0994 15.2921 12.6073 14.7999 12 14.7998ZM11.3496 13H12.6504L13 7H11L11.3496 13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconExclamationCircleBold;
